import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import ListingBlockLayout from '@/app/components/listing/ListingBlockLayout.vue'
import PodcastCardSkeleton from '@/app/components/listing/skeleton-loaders/PodcastCardSkeleton.vue'

const numberOfCardsToRender = 4

export default /*@__PURE__*/_defineComponent({
  __name: 'PodcastsBlockSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListingBlockLayout, {
    title: "Podcasts",
    class: "podcasts-block-skeleton"
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(numberOfCardsToRender, (i) => {
        return _createVNode(PodcastCardSkeleton, { key: i })
      }), 64))
    ]),
    _: 1
  }))
}
}

})